import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const adminDeliverRewardsEndpoint = {
    authentication: authenticationTypes.authenticated,
    authenticationRole: userGroups.admin,
    endpointType: otherEndpointType,
    payloadSchema: {
        type: 'object',
        properties: {
            rewardsOwnerUserId: {
                type: 'string',
            },
            targetUserId: {
                type: 'string',
            },
            productKey: {
                type: 'string',
            },
            amount: {
                type: 'integer',
            },
            rewardFor: {
                type: 'string',
                enum: ['fans', 'creator'],
            },
        },
        required: ['rewardsOwnerUserId', 'targetUserId', 'productKey', 'amount', 'rewardFor'],
    },
};
